<ng-container *transloco="let t; read: 'upload'">
  <div class="p-5">
    <div class="flex justify-between items-center">
      <drdp-title [title]="t('uploadCenter.title')"></drdp-title>
    </div>

    <div class="flex flex-wrap gap-4 py-3">

      <drdp-container (drop)="uploadUserDropHandler($event)" color="whiteDash" class="h-62 w-80">
        <div class="w-full pb-4 text-center">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
          <p class="text-[15px]" [title]="t('uploadCenter.uploadUsers')">{{ t('uploadCenter.uploadUsers') }}</p>

          <p class="text-[15px] pt-11">{{ t('uploadCenter.dragAndDrop') }}</p>
          <p class="text-[15px]">{{ t('uploadCenter.or') }}</p>
          <div class="form-group">
            <label class="text-drdpblue-300 text-[15px]" (click)="userFileInput.click()">{{ t('uploadCenter.browseFile') }}</label>
            <input class="invisible" #userFileInput (change)="onFileChangeUser($event)" type="file" id="userfileUpload">
          </div>
        </div>
      </drdp-container>

      <drdp-container (drop)="uploadClassDropHandler($event)" color="whiteDash" class="h-62 w-80">
        <div class="w-full pb-4 text-center">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
          <p class="text-[15px]" [title]="t('uploadCenter.uploadClass')">{{ t('uploadCenter.uploadClass') }}</p>

          <p class="text-[15px] pt-11">{{ t('uploadCenter.dragAndDrop') }}</p>
          <p class="text-[15px]">{{ t('uploadCenter.or') }}</p>
          <div class="form-group">
            <label class="text-drdpblue-300 text-[15px]" (click)="classFileInput.click()">{{ t('uploadCenter.browseFile') }}</label>
            <input class="invisible" #classFileInput (change)="onFileChangeClass($event)" type="file" id="classfileUpload">
          </div>
        </div>
      </drdp-container>


      <!-- <drdp-container (drop)="uploadChildDropHandler($event)" color="whiteDash" class="h-62 w-80">
      <div class="w-full pb-4 text-center">
        <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
        <p class="text-[15px]" title="Upload All Instrument Child">Upload All Instrument Child</p>
        <p class="text-[15px]">(100 or less children)</p>

        <p class="text-[15px] pt-5">Drag and drop here</p>
        <p class="text-[15px]">OR</p>
        <div class="form-group">
          <label class="text-drdpblue-300 text-[15px]" (click)="childFileInput.click()">Browse File</label>
          <input class="invisible" #childFileInput (change)="onFileChange($event)" type="file" id="childfileUpload">
        </div>
      </div>
    </drdp-container> -->

    @if (enforce2025 === false || overrideRatings) {
      <drdp-container (drop)="uploadConsoleChildDropHandler($event, UploadTypes.moreThan201Student)" color="whiteDash" class="h-62 w-80">
        <div class="w-full pb-4 text-center">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
          <p class="text-[15px]" [title]="t('uploadCenter.uploadChild2015')">{{ t('uploadCenter.uploadChild2015') }}</p>
          <!-- <p class="text-[15px]">(101 or more children)</p> -->

          <p class="text-[15px] pt-11">{{ t('uploadCenter.dragAndDrop') }}</p>
          <p class="text-[15px]">{{ t('uploadCenter.or') }}</p>
          <div class="form-group">
            <label class="text-drdpblue-300 text-[15px]" (click)="moreChildFileInput.click()">{{ t('uploadCenter.browseFile') }}</label>
            <input class="invisible" #moreChildFileInput (change)="onFileChangeMoreChildren($event, UploadTypes.moreThan201Student)" type="file" id="moreChildfileUpload">
          </div>
        </div>
    </drdp-container>

    @if (isCalifornia) {
      <drdp-container (drop)="uploadConsoleChildDropHandler($event, UploadTypes.student2025)" color="whiteDash" class="h-62 w-80">
        <div class="w-full pb-4 text-center">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
          <p class="text-[15px]" [title]="t('uploadCenter.uploadChild2025EarlyAdopter')">{{ t('uploadCenter.uploadChild2025EarlyAdopter') }}</p>
          <p class="text-[15px] pt-11">{{ t('uploadCenter.dragAndDrop') }}</p>
          <p class="text-[15px]">{{ t('uploadCenter.or') }}</p>
          <div class="form-group">
            <label class="text-drdpblue-300 text-[15px]" (click)="moreChild2025FileInput.click()">{{ t('uploadCenter.browseFile') }}</label>
            <input class="invisible" #moreChild2025FileInput (change)="onFileChangeMoreChildren($event, UploadTypes.student2025)" type="file" id="moreChild2025fileUpload">
          </div>
        </div>
      </drdp-container>
    }
  }

    @if (enforce2025) {
      <drdp-container (drop)="uploadConsoleChildDropHandler($event, UploadTypes.student2025Final)" color="whiteDash" class="h-62 w-80">
        <div class="w-full pb-4 text-center">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-upload"></i>
          <p class="text-[15px]" [title]="t('uploadCenter.uploadChild2025')">{{ t('uploadCenter.uploadChild2025') }}</p>
          <p class="text-[15px] pt-11">{{ t('uploadCenter.dragAndDrop') }}</p>
          <p class="text-[15px]">{{ t('uploadCenter.or') }}</p>
          <div class="form-group">
            <label class="text-drdpblue-300 text-[15px]" (click)="moreChildFieldStudyFileInput.click()">{{ t('uploadCenter.browseFile') }}</label>
            <input class="invisible" #moreChildFieldStudyFileInput (change)="onFileChangeMoreChildren($event, UploadTypes.student2025Final)" type="file" id="moreChildFieldStudyfileUpload">
          </div>
        </div>
      </drdp-container>
    }
  </div>
  </div>

</ng-container>
